import * as Yup from 'yup'

const translatorValidation = Yup.object({
  firstName: Yup.string()
    .min(3, 'Debe tener al menos 3 caracteres')
    .max(40, 'Debe tener como mucho 40 caracteres')
    .required('Obligatorio'),
  lastName: Yup.string()
    .min(3, 'Debe tener al menos 3 caracteres')
    .max(40, 'Debe tener como mucho 40 caracteres')
    .required('Obligatorio'),
  speciality: Yup.string().required('Obligatorio'),
})

export default translatorValidation
